<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M7.525 7.808a.645.645 0 0 1-.192-.475V2c0-.189.064-.347.192-.475A.645.645 0 0 1 8 1.333c.189 0 .347.064.475.192A.645.645 0 0 1 8.667 2v5.333a.645.645 0 0 1-.192.475A.645.645 0 0 1 8 8a.645.645 0 0 1-.475-.192Zm-1.867 5.717a6.1 6.1 0 0 1-1.9-1.283 6.1 6.1 0 0 1-1.283-1.9A5.805 5.805 0 0 1 2 8c0-.678.111-1.336.333-1.975A5.978 5.978 0 0 1 3.3 4.267a.546.546 0 0 1 .467-.225c.189.005.355.08.5.225a.559.559 0 0 1 .166.45.95.95 0 0 1-.183.5c-.3.4-.528.839-.683 1.316A4.709 4.709 0 0 0 3.333 8c0 1.3.453 2.403 1.359 3.308.905.906 2.008 1.359 3.308 1.359 1.3 0 2.403-.453 3.308-1.359.906-.905 1.359-2.008 1.359-3.308a5.01 5.01 0 0 0-.225-1.492 3.97 3.97 0 0 0-.709-1.325.856.856 0 0 1-.183-.475.548.548 0 0 1 .167-.441.689.689 0 0 1 .483-.209.561.561 0 0 1 .467.209 5.93 5.93 0 0 1 .991 1.75C13.886 6.65 14 7.31 14 8c0 .833-.158 1.614-.475 2.342a6.1 6.1 0 0 1-1.283 1.9 6.1 6.1 0 0 1-1.9 1.283A5.804 5.804 0 0 1 8 14a5.804 5.804 0 0 1-2.342-.475Z"
        />
    </svg>
</template>

<script setup lang="ts">
type ModeOnIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<ModeOnIconProps>();
</script>
